import { render, staticRenderFns } from "./RetreatCatering.vue?vue&type=template&id=6685329e&scoped=true"
import script from "./RetreatCatering.vue?vue&type=script&lang=js"
export * from "./RetreatCatering.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6685329e",
  null
  
)

export default component.exports